<template>
  <h1>ReasonList</h1>
</template>

<script>
export default {
  name: "ReasonList"
};
</script>

<style></style>
